module.exports = __webpack_public_path__ + "static/shopify_marketplace-359ad7a5abc9fea4a2f485cfa3f155cc.png";